var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BaseInlineSwitch',{attrs:{"section-name":_vm.sectionName,"label":"add-ons"},model:{value:(_vm.showAddOns),callback:function ($$v) {_vm.showAddOns=$$v},expression:"showAddOns"}})
}
var staticRenderFns = []

export { render, staticRenderFns }